(() => {
  const updateHeader = () => document.body.classList.toggle('florence-scrolled', window.scrollY > 80);
  updateHeader();
  window.addEventListener('scroll', updateHeader, {passive: true});

  const initialize = (root = document) => {
    root.querySelectorAll('[data-home-slideshow]').forEach(slideshow => {
      if (slideshow.dataset.ready) return;
      slideshow.dataset.ready = 'true';
      const slides = [...slideshow.querySelectorAll('[data-home-slide]')];
      const controls = slideshow.querySelector('[data-slide-controls]');
      if (slides.length < 2 || !controls) return;
      const buttons = [...controls.querySelectorAll('[data-show-slide]')];
      const pauseButton = controls.querySelector('[data-slide-pause]');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      let active = 0;
      let paused = reduced.matches;
      let timer;
      const show = index => {
        active = index;
        slides.forEach((slide, i) => { slide.hidden = i !== index; });
        buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      };
      const updatePause = () => {
        pauseButton.textContent = paused ? '▶' : 'Ⅱ';
        pauseButton.setAttribute('aria-label', paused ? pauseButton.dataset.playLabel : pauseButton.dataset.pauseLabel);
      };
      const restart = () => {
        window.clearTimeout(timer);
        if (paused || document.hidden || slideshow.matches(':focus-within')) return;
        timer = window.setTimeout(() => { show((active + 1) % slides.length); restart(); }, Number(slideshow.dataset.interval) || 9000);
      };
      buttons.forEach((button, index) => button.addEventListener('click', () => { paused = true; show(index); updatePause(); restart(); }));
      pauseButton.addEventListener('click', () => { paused = !paused; updatePause(); restart(); });
      slideshow.addEventListener('focusin', () => window.clearTimeout(timer));
      slideshow.addEventListener('focusout', restart);
      slideshow.addEventListener('mouseenter', () => window.clearTimeout(timer));
      slideshow.addEventListener('mouseleave', restart);
      document.addEventListener('visibilitychange', restart);
      reduced.addEventListener('change', () => { paused = reduced.matches; updatePause(); restart(); });
      controls.hidden = false;
      updatePause();
      restart();
    });
    root.querySelectorAll('[data-community-quotes]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const track = section.querySelector('.florence-quotes__grid');
      const quotes = [...track.querySelectorAll('blockquote')];
      const controls = section.querySelector('[data-quote-controls]');
      const buttons = [...controls.querySelectorAll('[data-show-quote]')];
      if (quotes.length < 2) return;
      controls.hidden = false;
      buttons.forEach((button, index) => button.addEventListener('click', () => {
        track.scrollTo({left: quotes[index].offsetLeft - quotes[0].offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }));
      track.addEventListener('scroll', () => {
        const index = Math.round(track.scrollLeft / track.clientWidth);
        buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      }, {passive: true});
    });
    root.querySelectorAll('[data-footer-disclosure]').forEach(details => {
      if (details.dataset.ready) return;
      details.dataset.ready = 'true';
      const mobile = window.matchMedia('(max-width: 767px)');
      const update = () => { details.open = !mobile.matches; };
      update();
      mobile.addEventListener('change', update);
    });
    root.querySelectorAll('[data-play-film]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const id = encodeURIComponent(button.dataset.videoId || '');
        if (!id) return;
        const iframe = document.createElement('iframe');
        iframe.src = button.dataset.videoType === 'vimeo' ? `https://player.vimeo.com/video/${id}?autoplay=1` : `https://www.youtube-nocookie.com/embed/${id}?autoplay=1`;
        iframe.title = button.dataset.videoTitle;
        iframe.allow = 'autoplay; fullscreen; picture-in-picture';
        iframe.allowFullscreen = true;
        const container = button.closest('[data-brand-film]');
        container.replaceChildren(iframe);
        iframe.focus();
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
